// eslint-disable-next-line max-len
import {AspectRatio, Box, Divider, Heading, HStack, Radio, RadioGroup, Stack, Text, VStack} from '@chakra-ui/react';
import Image from 'next/image';
import s from './ProductDetail.module.css';
import cartContext from '../../../store/cart_context';
import {useContext, useEffect, useState} from 'react';
import {forEach, isEmpty} from 'lodash';
import ImageSlides from './ImageSlides';

const ProductDetail = ({product}) => {
  const cartCtx = useContext(cartContext);
  const [curVariant, setCurVariant] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [priceString, setPriceString] = useState('');

  console.log(product);

  useEffect(() => {
    if (!product.hasVariants) {
      setCurVariant(product);
      setPriceString(`$${product.price / 100}`);
    } else {
      const options = [];
      forEach(product.variants, (variant) => {
        forEach(variant.labels, (label) => {
          const option = options.find((option) => option.name === label.label);
          if (option) {
            // eslint-disable-next-line max-len
            const value = option.values.find((value) => value.value === label.value);
            if (!value) {
              option.values.push({
                value: label.value,
                available: true,
              });
            }
          } else {
            options.push({
              name: label.label,
              values: [{
                value: label.value,
                available: true,
              }],
            });
          }
        });
      });
      setOptions(options);
      update();
    }
  }, []);

  useEffect(() => {
    if (product.hasVariants) {
      update();
    }
  }, [selectedOptions]);

  const update = () => {
    let lowestPrice = Infinity;
    let highestPrice = 0;
    const availableVariants = isEmpty(selectedOptions) ? product.variants :
            product.variants.filter((variant) => {
              return selectedOptions.every((option) => {
                return variant.labels.some((label) => {
                  return label.label === option.name &&
                            label.value === option.value;
                });
              });
            });
    availableVariants?.forEach((variant) => {
      if (variant.price < lowestPrice) {
        lowestPrice = variant.price;
      }
      if (variant.price > highestPrice) {
        highestPrice = variant.price;
      }
    });

    // update price
    if (lowestPrice === highestPrice) {
      setPriceString(`$${lowestPrice / 100}`);
    } else {
      setPriceString(`$${lowestPrice / 100} - $${highestPrice / 100}`);
    }

    // update curVariant
    if (availableVariants?.length === 1) {
      setCurVariant({
        ...product,
        price: availableVariants[0].price,
        stripePriceId: availableVariants[0].stripePriceId,
        // eslint-disable-next-line max-len
        productName: product.productName + ' - ' + availableVariants[0].labels.map((label) => label.value).join(' - '),
      });
    }
  };

  const onOptionChange = (optionName, value) => {
    const newSelectedOptions = [...selectedOptions];
    const option = newSelectedOptions.find((option) =>
      option.name === optionName);
    if (option) {
      option.value = value;
    } else {
      newSelectedOptions.push({
        name: optionName,
        value,
      });
    }
    setSelectedOptions(newSelectedOptions);
  };


  return (
    <Stack
      direction={{base: 'column', md: 'row'}}
      width={'100%'}
      spacing={5}>
      <Box
        flex={1}>
        <ImageSlides
          imageUrls={product.images}/>
      </Box>
      <VStack
        flex={1}
        alignItems={'start'}>
        <Heading>{product.productName}</Heading>
        <Text color='blue.600' fontSize='3xl'>
          {priceString}
        </Text>
        <Divider />
        {options.map((option) => (
          <Box
            key={option.name}>
            <Heading size={'sm'}>{option.name}</Heading>
            <RadioGroup
              onChange={(value) => onOptionChange(option.name, value)}
              value={selectedOptions.find((o) =>
                o.name === option.name)?.value}>
              <HStack>
                {option.values.map((value) => (
                  <Radio
                    isDisabled={!value.available}
                    key={value.value}
                    value={value.value}>{value.value}</Radio>
                ))}
              </HStack>
            </RadioGroup>
          </Box>
        ))}
        <Divider />
        <Text
          whiteSpace={'pre-wrap'}
          fontSize={'xl'}>
          {product.description}
        </Text>
        {curVariant !== null &&
              <button
                onClick={() => cartCtx.addCartItem(curVariant)}
                className={`custom__button ${s.add_cart}`}>Add To Cart</button>}
      </VStack>
    </Stack>
  );
};

export default ProductDetail;
